// Poyais One > Akıllı Kitleler (Smart Audiences): site davranışından RFM benzeri kitleler kurar,
// müşterinin Meta ve Google Ads hesabına kural tabanlı kitle olarak yazar; backend her gün eşitler.
// Backend: /api/v1/smart-audiences (app/smart_audiences.py).
import React, { useEffect, useMemo, useRef, useState } from 'react';
import axios from 'axios';
import { T, tint } from './poyais-ui/theme';
import { Card, Badge, Button } from './poyais-ui/primitives';
import { Sparkline } from './poyais-ui/charts';
import { useIsMobile } from './poyais-ui/hooks';
import { useLang, addTranslations } from './i18n';

addTranslations({
  'Sitenizdeki davranışa göre müşterilerinizi segmentlere ayırın; kitleler Meta ve Google Ads hesabınıza aktarılır ve her gün güncellenir.':
    'Segment your customers by on-site behavior; audiences are pushed to your Meta and Google Ads accounts and refreshed every day.',
  'Yeni Kitle': 'New Audience', 'Kitleleriniz': 'Your Audiences', 'Hazır Şablonlar': 'Templates',
  'Müşteri Değeri (RFM)': 'Customer Value (RFM)', 'Satın Almaya Yakın': 'Close to Buying', 'Hariç Tutma': 'Exclusion',
  'Yakınlık, sıklık ve harcamaya göre müşteri segmentleri.': 'Customer segments by recency, frequency and spend.',
  'Sitede ilgi gösterip satın almayan sıcak kitleler.': 'Warm visitors who showed interest but did not buy.',
  'Yeni müşteri kampanyalarında dışarıda bırakılacak kitleler.': 'Audiences to leave out of prospecting campaigns.',
  'Kitle': 'Audience', 'Trend': 'Trend',
  'Kur': 'Set Up', 'Kuruldu': 'Added', 'Düzenle': 'Edit', 'Sil': 'Delete', 'Şimdi Eşitle': 'Sync Now',
  'Duraklat': 'Pause', 'Devam Ettir': 'Resume', 'Duraklatıldı': 'Paused',
  'Hazır': 'Ready', 'Hata': 'Error', 'Uyarı': 'Warning', 'Desteklenmiyor': 'Not Supported', 'Bekliyor': 'Pending',
  'Bağlı Değil': 'Not Connected', 'Dolduruluyor': 'Populating',
  'Platform kitleyi geçmiş verilerle dolduruyor. Kitle reklamda hemen kullanılabilir; boyut birkaç saat içinde büyür.':
    'The platform is filling the audience from past data. You can use it in ads right away; the size grows over the next hours.', 'Hesap Kapalı': 'Account Closed', 'Hesaplanıyor': 'Calculating',
  'Sadece Meta': 'Meta Only', 'Son Eşitleme': 'Last sync', 'Önerilen kullanım': 'Suggested use',
  'Şablon Seçin': 'Pick a Template', 'Reklam Hesabına Aktarılır': 'Pushed to Your Ad Account', 'Her Gün Güncellenir': 'Refreshed Daily',
  'Hazır RFM şablonlarından birini seçin ya da kendi kuralınızı yazın.': 'Pick a ready RFM template or write your own rule.',
  'Kitle Meta ve Google Ads hesabınızda kural olarak oluşur, kampanyalarda hemen seçilebilir.': 'The audience is created as a rule in your Meta and Google Ads accounts and can be targeted right away.',
  'Platformlar üyeliği sürekli günceller; Poyais One her gün eşitler ve boyutu izler.': 'Platforms keep membership current; Poyais One syncs daily and tracks size.',
  'Kitle Adı': 'Audience Name', 'Kimler Dahil?': 'Who Is Included?', 'Kimler Hariç?': 'Who Is Excluded?',
  'Zaman Aralığı': 'Time Window', 'Son': 'Last', 'gün': 'days', 'Gün': 'Days', 'Özel': 'Custom',
  'Ek Koşullar': 'Extra Conditions', 'En Az Satın Alma Sayısı': 'Minimum Purchases', 'Tek Siparişte En Az Tutar': 'Minimum Single-Order Value',
  'Platformlar': 'Platforms', 'Vazgeç': 'Cancel', 'Kaydet ve Aktar': 'Save & Push', 'Kaydediliyor…': 'Saving…',
  'Bu Kitle': 'This Audience', 'Bağlı': 'Connected', 'Bu kurguyu desteklemiyor': 'Does not support this rule',
  'Hariç tutulacak bir davranış ekleyin': 'Add a behavior to exclude',
  'Bu kitle platformlardan da silinsin mi? Kampanyalarda kullanılıyorsa hedeflemeden düşer.': 'Delete this audience from the ad platforms too? Campaigns using it will lose this targeting.',
  'Kişisel veri (e-posta/telefon) yüklenmez; kitleler reklam hesabınızda piksel ve etiket kuralı olarak oluşur. Google listeleri geçmiş 30 günle, Meta kitleleri 180 güne kadar geçmişle dolar.':
    'No personal data (email/phone) is uploaded; audiences are pixel and tag rules in your ad account. Google lists are prefilled with 30 days of history, Meta audiences with up to 180 days.',
  'Görüntüleme yetkiniz var; kitle eklemek için Düzenleyici rolü gerekir.': 'You have view access; adding audiences requires the Editor role.',
  'Yakınlık': 'Recency', 'Sıklık': 'Frequency', 'Tutar': 'Monetary',
  'Çapraz Satış': 'Upsell', 'Sadakat': 'Loyalty', 'Geri Kazanım': 'Win-back', 'Yeniden Pazarlama': 'Retargeting', 'Hariç Tutma Listesi': 'Exclusion List',
  'Satın Alma': 'Purchase', 'Sepete Ekleme': 'Add to Cart', 'Ödeme Başlatma': 'Initiate Checkout', 'Ürün Görüntüleme': 'Product View',
  'Hariç': 'Exclude', 'En Az': 'At Least', 'Sipariş ≥': 'Order ≥',
  'Sıklık koşulu sadece Meta\'da çalışır.': 'The frequency condition works on Meta only.',
  'Poyais One AI Önerileri': 'Poyais One AI Suggestions',
  'Verileriniz (GA4, reklam performansı) kitle adaylarına çevrilir; kitle boyutları ve dönüşüm oranları ölçülmüş verilerdir, AI sadece önceliklendirir ve gerekçelendirir. Hiçbir kitle sizin onayınız olmadan kurulmaz.':
    'Your data (GA4, ad performance) is turned into audience candidates; sizes and conversion rates are measured data, AI only prioritizes and explains. No audience is created without your approval.',
  'Analiz Et': 'Analyze', 'Yeniden Analiz Et': 'Re-analyze', 'Analiz ediliyor… (30–60 sn)': 'Analyzing… (30–60 s)',
  'Son Analiz': 'Last analysis', 'Beslendiği Kaynaklar': 'Data sources',
  'Yüksek Öncelik': 'High Priority', 'Orta Öncelik': 'Medium Priority', 'Düşük Öncelik': 'Low Priority',
  'Tahmini Kitle': 'Est. Audience', 'Aşama Dönüşümü': 'Stage Conversion', 'son 30 gün, kıyas değeri': 'last 30 days, benchmark',
  'Yoksay': 'Dismiss', 'Benzer kitle tohumu olabilir': 'Can seed a lookalike',
  'Henüz analiz yapılmadı. Poyais One AI müşterinizin verisini inceleyip size özel kitleler önersin.': 'No analysis yet. Let Poyais One AI review your data and suggest audiences made for you.',
  'Otomatik sıralama kullanıldı (AI yanıt vermedi).': 'Automatic ranking was used (AI did not respond).',
  'Yeni öneri yok. Mevcut kitleleriniz verinizle uyumlu görünüyor.': 'No new suggestions. Your current audiences fit your data.',
  'Benzer Kitle Oluştur': 'Create Lookalike', 'Benzer Kitle': 'Lookalike', 'Hedef Ülke': 'Target Country', 'Benzerlik Oranı': 'Similarity Ratio',
  'Dar oran kaynağa daha çok benzer, geniş oran daha çok kişiye ulaşır. Birkaç oranı birlikte seçip test edebilirsiniz.':
    'Narrow ratios resemble the source more closely, wide ratios reach more people. You can pick several ratios and test them together.',
  'Meta, benzer kitle için kaynak kitlenin en az 100 kişi olmasını ister.': 'Meta requires the source audience to have at least 100 people for a lookalike.',
  'Oluştur': 'Create', 'Oluşturuluyor…': 'Creating…', 'Sadece Meta\'da': 'Meta only',
  'Sayfa Ziyareti': 'Page Visit', 'Sayfa adresi şunu içeriyorsa': 'Page address contains', 'Örn. /collections/kadin': 'e.g. /collections/women',
  'Seçili süre ve olay için sayfa adresini yazın.': 'Enter the page address for the selected window.',
  'Kolay Ayarlanabilir': 'Easy to tune',
});

type Side = { event: string; days: number; url?: string };
type Spec = { include: Side; exclude?: Side | null; min_count?: number | null; min_value?: number | null };
type Template = { key: string; name: string; desc: string; rfm: string; use: string; spec: Spec; google_note: string };
type Audience = {
  id: number; client_id: number; template_key: string; name: string; spec: Spec; platforms: string[]; enabled: boolean;
  last_sync_at?: string; meta_status?: string; meta_error?: string; meta_size_low?: number | null; meta_size_high?: number | null;
  google_status?: string; google_error?: string; google_size_display?: number | null; google_size_search?: number | null;
  google_note: string; history: { day: string; platform: string; size: number }[];
  lookalikes?: Lookalike[];
};
type Lookalike = { id: number; country: string; ratio: number; status: string; error: string; size_low?: number | null; size_high?: number | null };
type Suggestion = {
  id: number; name: string; spec: Spec; kind: string; priority: number; rationale: string; use_case: string; watch_out: string;
  est_size?: number | null; est_rate?: number | null; size_note: string; meta_only: boolean; lookalike_ok: boolean; ai: boolean;
};
type SugState = { items: Suggestion[]; running: boolean; status: string; error: string; analyzed_at?: string | null; sources: string[]; ai: boolean; can_write: boolean };
type Plat = 'meta' | 'google';

const API = '/api/v1/smart-audiences';
const PLATS: Plat[] = ['meta', 'google'];
const PLAT = { meta: { label: 'Meta', logo: '/meta-icon.png' }, google: { label: 'Google Ads', logo: '/google-ads-icon.png' } } as const;
const EVENTS: { key: string; label: string; icon: string }[] = [
  { key: 'Purchase', label: 'Satın Alma', icon: 'shopping_bag' },
  { key: 'AddToCart', label: 'Sepete Ekleme', icon: 'add_shopping_cart' },
  { key: 'InitiateCheckout', label: 'Ödeme Başlatma', icon: 'credit_card' },
  { key: 'ViewContent', label: 'Ürün Görüntüleme', icon: 'visibility' },
  { key: 'PageView', label: 'Sayfa Ziyareti', icon: 'web' },
];
const EVENT_LABEL: Record<string, string> = Object.fromEntries(EVENTS.map(e => [e.key, e.label]));
const DAY_CHIPS = [7, 14, 30, 60, 90, 180];
const USE_LABEL: Record<string, string> = { upsell: 'Çapraz Satış', loyalty: 'Sadakat', winback: 'Geri Kazanım', retarget: 'Yeniden Pazarlama', exclude: 'Hariç Tutma Listesi' };
const RFM_LABEL: Record<string, string> = { R: 'Yakınlık', F: 'Sıklık', M: 'Tutar' };

// Şablon görünümü: ikon, renk, grup ve somut kullanım önerisi (TR / EN).
const LOOK: Record<string, { icon: string; color: string; group: string; tip: [string, string]; en: [string, string] }> = {
  new_buyers: { icon: 'person_add', color: T.green, group: 'rfm',
    tip: ['Tamamlayıcı ürünlerle çapraz satış kampanyasına hedefleyin.', 'Target with complementary products in a cross-sell campaign.'],
    en: ['New Customers', 'Bought in the last 30 days. For cross-sell and second-order campaigns.'] },
  loyal: { icon: 'favorite', color: T.purple, group: 'rfm',
    tip: ['Yeni koleksiyon duyurularında öncelikli gösterin, benzer kitle tohumu yapın.', 'Show new collections to them first and use them as a lookalike seed.'],
    en: ['Loyal Customers', 'Bought at least twice in the last 180 days. For new collections and VIP messaging.'] },
  high_value: { icon: 'diamond', color: T.accent, group: 'rfm',
    tip: ['Benzer kitle tohumu olarak kullanın; indirim yerine ayrıcalık iletişimi yapın.', 'Use as a lookalike seed; message exclusivity rather than discounts.'],
    en: ['Big Spenders', 'Spent above your threshold in a single order in the last 180 days. A strong lookalike seed too.'] },
  at_risk: { icon: 'hourglass_bottom', color: T.amber, group: 'rfm',
    tip: ['"Sizi özledik" mesajı ve sınırlı süreli teklifle geri kazanım kampanyası kurun.', 'Run a win-back campaign with a "we miss you" message and a time-limited offer.'],
    en: ['At Risk', 'Bought 60–180 days ago and not since. For win-back offers.'] },
  cart_abandon: { icon: 'remove_shopping_cart', color: T.blue, group: 'warm',
    tip: ['Dinamik ürün reklamıyla sepetteki ürünleri hatırlatın.', 'Remind them of their cart with dynamic product ads.'],
    en: ['Cart Abandoners', 'Added to cart in the last 14 days without buying.'] },
  checkout_abandon: { icon: 'credit_card_off', color: T.red, group: 'warm',
    tip: ['Kargo bedava veya taksit mesajıyla son adımı tamamlatın.', 'Close the last step with free shipping or installment messaging.'],
    en: ['Checkout Abandoners', 'Reached checkout in the last 7 days without completing. The hottest audience.'] },
  browsers: { icon: 'visibility', color: T.blue, group: 'warm',
    tip: ['Baktıkları kategorideki çok satanlarla yeniden hedefleyin.', 'Retarget with best sellers from the category they browsed.'],
    en: ['Product Browsers', 'Viewed a product in the last 30 days without adding to cart.'] },
  all_buyers: { icon: 'block', color: T.textDim, group: 'exclude',
    tip: ['Yeni müşteri kampanyalarında hariç tutun, bütçe mevcut müşterilere gitmesin.', 'Exclude from prospecting so budget is not spent on existing customers.'],
    en: ['All Buyers', 'Everyone who bought in the last 180 days. Exclude them from prospecting campaigns.'] },
};
const GROUPS: { key: string; title: string; sub: string }[] = [
  { key: 'rfm', title: 'Müşteri Değeri (RFM)', sub: 'Yakınlık, sıklık ve harcamaya göre müşteri segmentleri.' },
  { key: 'warm', title: 'Satın Almaya Yakın', sub: 'Sitede ilgi gösterip satın almayan sıcak kitleler.' },
  { key: 'exclude', title: 'Hariç Tutma', sub: 'Yeni müşteri kampanyalarında dışarıda bırakılacak kitleler.' },
];
const CUSTOM_LOOK = { icon: 'tune', color: T.accent };

const errText = (e: any) => e?.response?.data?.detail || e?.message || 'Hata';

function Sym({ name, size = 18, color, style }: { name: string; size?: number; color?: string; style?: React.CSSProperties }) {
  return <span className="material-symbols-outlined" style={{ fontSize: size, lineHeight: 1, color, flexShrink: 0, ...style }}>{name}</span>;
}

function IconTile({ icon, color, size = 40 }: { icon: string; color: string; size?: number }) {
  return (
    <div style={{ width: size, height: size, borderRadius: 12, background: tint(color, 14), display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
      <Sym name={icon} size={Math.round(size * 0.5)} color={color} />
    </div>
  );
}

function PlatLogo({ p, size = 16 }: { p: Plat; size?: number }) {
  return <img src={PLAT[p].logo} alt={PLAT[p].label} width={size} height={size} style={{ objectFit: 'contain', borderRadius: 4, flexShrink: 0 }} />;
}

function Chip({ children, tone = 'neutral' }: { children: React.ReactNode; tone?: 'neutral' | 'exclude' | 'cond' }) {
  const c = tone === 'exclude' ? T.redText : tone === 'cond' ? T.purpleText : T.textMid;
  const bg = tone === 'neutral' ? T.subtleBg : tint(tone === 'exclude' ? T.red : T.purple, 10);
  return <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 11.5, fontWeight: 600, padding: '3px 8px', borderRadius: 7, background: bg, color: c, whiteSpace: 'nowrap' }}>{children}</span>;
}

function useFmt() {
  const { lang } = useLang();
  return (n: number) => n.toLocaleString(lang === 'en' ? 'en-US' : 'tr-TR');
}

// Kural etiketleri: "Satın Alma · Son 180 Gün", "Hariç: Satın Alma · Son 60 Gün", "En Az 2 Satın Alma".
function RuleChips({ s }: { s: Spec }) {
  const { t } = useLang();
  const side = (x: Side) => `${t(EVENT_LABEL[x.event])}${x.url ? ` · ${x.url.length > 34 ? x.url.slice(0, 33) + '…' : x.url}` : ''} · ${t('Son')} ${x.days} ${t('Gün')}`;
  return (
    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
      <Chip>{side(s.include)}</Chip>
      {s.min_count ? <Chip tone="cond">{t('En Az')} {s.min_count}× {t('Satın Alma')}</Chip> : null}
      {s.exclude && <Chip tone="exclude">{t('Hariç')}: {side(s.exclude)}</Chip>}
    </div>
  );
}

// Kuralı tek cümleyle anlatır (editör önizlemesi).
function useDescribe() {
  const { lang } = useLang();
  return (s: Spec) => {
    const tr = lang !== 'en';
    const vTr: Record<string, [string, string]> = {
      Purchase: ['satın alan', 'satın almayan'], AddToCart: ['sepete ekleyen', 'sepete eklemeyen'],
      InitiateCheckout: ['ödeme başlatan', 'ödeme başlatmayan'], ViewContent: ['ürün görüntüleyen', 'ürün görüntülemeyen'],
      PageView: ['sayfayı ziyaret eden', 'sayfayı ziyaret etmeyen'],
    };
    const vEn: Record<string, [string, string]> = {
      Purchase: ['purchased', 'did not purchase'], AddToCart: ['added to cart', 'did not add to cart'],
      InitiateCheckout: ['started checkout', 'did not start checkout'], ViewContent: ['viewed a product', 'did not view a product'],
      PageView: ['visited the page', 'did not visit the page'],
    };
    const v = tr ? vTr : vEn;
    const u = (x: Side) => x.url ? (tr ? ` (${x.url})` : ` (${x.url})`) : '';
    let out = tr
      ? `Son ${s.include.days} günde${s.min_count ? ` en az ${s.min_count} kez` : ''} ${v[s.include.event]?.[0]}${u(s.include)}`
      : `People who ${v[s.include.event]?.[0]}${u(s.include)}${s.min_count ? ` at least ${s.min_count} times` : ''} in the last ${s.include.days} days`;
    if (s.exclude) out += tr ? `, son ${s.exclude.days} günde ${v[s.exclude.event]?.[1]}${u(s.exclude)}` : ` but ${v[s.exclude.event]?.[1]}${u(s.exclude)} in the last ${s.exclude.days} days`;
    return out + (tr ? ' kişiler.' : '.');
  };
}

// ── Kitle satırı ───────────────────────────────────────────────────────────

function platState(a: Audience, p: Plat) {
  if (!a.platforms.includes(p)) return { kind: 'off' as const };
  const status = p === 'meta' ? a.meta_status : a.google_status;
  const error = (p === 'meta' ? a.meta_error : a.google_error) || '';
  return { kind: 'on' as const, status: a.enabled ? status || '' : 'paused', error };
}

// Meta tahmini aralık verir (alt–üst); iki sınır eşitse tek sayı gösterilir.
function sizeText(a: Audience, p: Plat, fmt: (n: number) => string): string {
  if (p === 'meta') {
    const lo = a.meta_size_low, hi = a.meta_size_high;
    if (!hi) return '';
    return lo != null && lo !== hi ? `${fmt(lo)}–${fmt(hi)}` : fmt(hi);
  }
  return a.google_size_display != null ? fmt(a.google_size_display) : '';
}

function PlatCell({ a, p, compact }: { a: Audience; p: Plat; compact?: boolean }) {
  const { t } = useLang();
  const fmt = useFmt();
  const st = platState(a, p);
  let dot: string = T.textFaint, text: string = '—', title = '';
  if (st.kind === 'on') {
    title = st.error;
    switch (st.status) {
      case 'ready': {
        dot = T.green;
        text = sizeText(a, p, fmt) || t('Hesaplanıyor');
        break;
      }
      case 'populating': {
        // Platform geçmiş veriyle kitleyi dolduruyor: reklamda kullanılabilir, boyut henüz nihai değil.
        // Dolum sırasında platformun verdiği boyut geçici bir taban değer (Meta 20–20, Google 0); gösterilmez.
        dot = T.blue;
        text = t('Dolduruluyor');
        title = t('Platform kitleyi geçmiş verilerle dolduruyor. Kitle reklamda hemen kullanılabilir; boyut birkaç saat içinde büyür.');
        break;
      }
      case 'blocked': dot = T.amber; text = t('Hesap Kapalı'); break;
      case 'warning': dot = T.amber; text = t('Uyarı'); break;
      case 'error': dot = T.red; text = t('Hata'); break;
      case 'unsupported': text = t('Desteklenmiyor'); break;
      case 'not_connected': text = t('Bağlı Değil'); break;
      case 'paused': text = t('Duraklatıldı'); break;
      default: text = t('Bekliyor');
    }
  }
  return (
    <div title={title} style={{ display: 'flex', alignItems: 'center', gap: 7, minWidth: 0 }}>
      {compact && <PlatLogo p={p} size={14} />}
      <span style={{ width: 7, height: 7, borderRadius: 99, background: dot, flexShrink: 0 }} />
      <span style={{ fontSize: 13, fontWeight: 600, color: dot === T.textFaint ? T.textDim : T.text, fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{text}</span>
    </div>
  );
}

function RowMenu({ a, onAction, busy }: { a: Audience; onAction: (k: string) => void; busy: string }) {
  const { t } = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return;
    const close = (e: MouseEvent) => { if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, [open]);
  const items: [string, string, string, boolean?][] = [
    ['sync', 'sync', 'Şimdi Eşitle', !a.enabled],
    ['edit', 'edit', 'Düzenle'],
    ['lookalike', 'group_add', 'Benzer Kitle Oluştur', !a.enabled || !a.platforms.includes('meta') || !['ready', 'warning'].includes(a.meta_status || '')],
    ['toggle', a.enabled ? 'pause' : 'play_arrow', a.enabled ? 'Duraklat' : 'Devam Ettir'],
    ['delete', 'delete', 'Sil'],
  ];
  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button onClick={() => setOpen(o => !o)} aria-label="menu" disabled={!!busy}
        style={{ width: 32, height: 32, borderRadius: 9, border: `1px solid ${open ? T.borderMid : 'transparent'}`, background: open ? T.subtleBg : 'transparent', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: T.textMid }}>
        {busy ? <Sym name="progress_activity" size={18} style={{ animation: 'spin 1s linear infinite' }} /> : <Sym name="more_horiz" size={20} />}
      </button>
      {open && (
        <div style={{ position: 'absolute', right: 0, top: 36, zIndex: 20, minWidth: 220, background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12, boxShadow: '0 12px 32px rgba(15,17,35,.14)', padding: 5 }}>
          {items.map(([k, icon, label, disabled]) => (
            <button key={k} disabled={disabled} onClick={() => { setOpen(false); onAction(k); }}
              style={{ display: 'flex', alignItems: 'center', gap: 10, width: '100%', padding: '9px 10px', border: 'none', background: 'transparent', borderRadius: 8, cursor: disabled ? 'default' : 'pointer', fontFamily: 'inherit', fontSize: 13, fontWeight: 600, textAlign: 'left', whiteSpace: 'nowrap',
                color: disabled ? T.textFaint : k === 'delete' ? T.redText : T.text }}
              onMouseEnter={e => { if (!disabled) e.currentTarget.style.background = T.subtleBg; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; }}>
              <Sym name={icon} size={17} /> {t(label)}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

const GRID = 'minmax(0, 1fr) 150px 150px 84px 40px';

function AudienceRow({ a, canWrite, isMobile, first, onEdit, onLookalike, onChanged, onDeleted }:
  { a: Audience; canWrite: boolean; isMobile: boolean; first: boolean; onEdit: () => void; onLookalike: () => void; onChanged: (x: Audience) => void; onDeleted: () => void }) {
  const { t, lang } = useLang();
  const [busy, setBusy] = useState('');
  const [err, setErr] = useState('');
  const look = LOOK[a.template_key] || { ...CUSTOM_LOOK };
  const en = LOOK[a.template_key]?.en;
  const name = lang === 'en' && en && a.name === TEMPLATE_TR_NAME[a.template_key] ? en[0] : a.name;

  const run = async (kind: string, fn: () => Promise<any>) => {
    setBusy(kind); setErr('');
    try { await fn(); } catch (e) { setErr(errText(e)); } finally { setBusy(''); }
  };
  const onAction = (k: string) => {
    if (k === 'edit') return onEdit();
    if (k === 'lookalike') return onLookalike();
    if (k === 'sync') return run(k, async () => onChanged((await axios.post(`${API}/${a.id}/sync`)).data));
    if (k === 'toggle') return run(k, async () => onChanged((await axios.put(`${API}/${a.id}`, { client_id: a.client_id, name: a.name, spec: a.spec, platforms: a.platforms, enabled: !a.enabled })).data));
    if (k === 'delete' && window.confirm(t('Bu kitle platformlardan da silinsin mi? Kampanyalarda kullanılıyorsa hedeflemeden düşer.')))
      return run(k, async () => { await axios.delete(`${API}/${a.id}`); onDeleted(); });
  };

  const series = (a.history.filter(h => h.platform === 'meta').length > 1 ? a.history.filter(h => h.platform === 'meta') : a.history.filter(h => h.platform === 'google')).map(h => h.size);
  // Satır altı bildirim: hata/uyarı/hesap kapalı (desteklenmiyor ve bağlı değil bilgi amaçlı; hücrede yeterli).
  const notes = a.enabled ? PLATS.map(p => ({ p, st: platState(a, p) }))
    .filter(x => x.st.kind === 'on' && ['error', 'warning', 'blocked'].includes(x.st.status || '') && x.st.error) : [];

  const identity = (
    <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start', minWidth: 0 }}>
      <IconTile icon={look.icon} color={a.enabled ? look.color : T.textDim} size={38} />
      <div style={{ minWidth: 0, display: 'flex', flexDirection: 'column', gap: 6 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
          <span style={{ fontSize: 14, fontWeight: 800, color: a.enabled ? T.text : T.textMid }}>{name}</span>
          {!a.enabled && <Badge color={T.textDim}>{t('Duraklatıldı')}</Badge>}
        </div>
        <RuleChips s={a.spec} />
      </div>
    </div>
  );

  return (
    <div style={{ padding: '14px 18px', borderTop: first ? 'none' : `1px solid ${T.divider}` }}>
      {isMobile ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
            {identity}
            {canWrite && <RowMenu a={a} onAction={onAction} busy={busy} />}
          </div>
          <div style={{ display: 'flex', gap: 18, paddingLeft: 50 }}>
            {PLATS.map(p => <PlatCell key={p} a={a} p={p} compact />)}
          </div>
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: GRID, gap: 16, alignItems: 'center' }}>
          {identity}
          <PlatCell a={a} p="meta" />
          <PlatCell a={a} p="google" />
          <div>{series.length > 1 ? <Sparkline data={series} color={look.color} width={72} height={26} /> : <span style={{ fontSize: 12, color: T.textFaint }}>—</span>}</div>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>{canWrite && <RowMenu a={a} onAction={onAction} busy={busy} />}</div>
        </div>
      )}
      {(a.lookalikes || []).length > 0 && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginTop: 10, marginLeft: isMobile ? 0 : 50 }}>
          {(a.lookalikes || []).map(l => (
            <LookalikeRow key={l.id} l={l} canWrite={canWrite}
              onDelete={async () => { try { await axios.delete(`${API}/lookalikes/${l.id}`); onChanged({ ...a, lookalikes: (a.lookalikes || []).filter(x => x.id !== l.id) }); } catch (e) { setErr(errText(e)); } }} />
          ))}
        </div>
      )}
      {(notes.length > 0 || err) && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginTop: 10, marginLeft: isMobile ? 0 : 50 }}>
          {notes.map(({ p, st }) => {
            const warn = st.status !== 'error';
            return (
              <div key={p} style={{ display: 'flex', gap: 8, alignItems: 'flex-start', padding: '8px 10px', borderRadius: 10, background: warn ? T.amberTint : T.redTint }}>
                <PlatLogo p={p} size={14} />
                <span style={{ fontSize: 12, lineHeight: 1.5, color: warn ? T.amberDeepText : T.redText }}>{st.error}</span>
              </div>
            );
          })}
          {err && <div style={{ fontSize: 12, color: T.redText }}>{err}</div>}
        </div>
      )}
    </div>
  );
}

// ── Şablon kartı ───────────────────────────────────────────────────────────

const TEMPLATE_TR_NAME: Record<string, string> = {};

function TemplateCard({ tp, added, canWrite, onPick }: { tp: Template; added: boolean; canWrite: boolean; onPick: () => void }) {
  const { t, lang } = useLang();
  const look = LOOK[tp.key] || { ...CUSTOM_LOOK, tip: ['', ''], en: undefined };
  const en = LOOK[tp.key]?.en;
  const tip = LOOK[tp.key]?.tip;
  return (
    <Card pad={18} hover style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 10 }}>
        <IconTile icon={look.icon} color={look.color} />
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
          {tp.rfm && <Badge color={T.purpleText}>{tp.rfm} · {t(RFM_LABEL[tp.rfm])}</Badge>}
          <Badge color={T.blueText}>{t(USE_LABEL[tp.use] || tp.use)}</Badge>
        </div>
      </div>
      <div>
        <div style={{ fontSize: 15, fontWeight: 800, color: T.text }}>{lang === 'en' && en ? en[0] : tp.name}</div>
        <div style={{ fontSize: 12.5, color: T.textMid, lineHeight: 1.55, marginTop: 4 }}>{lang === 'en' && en ? en[1] : tp.desc}</div>
      </div>
      <RuleChips s={tp.spec} />
      {tip && (
        <div style={{ display: 'flex', gap: 8, alignItems: 'flex-start', fontSize: 12, color: T.textMid, lineHeight: 1.5, background: T.subtleBg, borderRadius: 10, padding: '8px 10px' }}>
          <Sym name="lightbulb" size={16} color={T.accent} />
          <span><b style={{ color: T.text }}>{t('Önerilen kullanım')}:</b> {lang === 'en' ? tip[1] : tip[0]}</span>
        </div>
      )}
      <div style={{ flex: 1 }} />
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, paddingTop: 12, borderTop: `1px solid ${T.divider}` }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <PlatLogo p="meta" size={18} />
          {tp.google_note
            ? <span style={{ fontSize: 11.5, fontWeight: 600, color: T.textDim }}>{t('Sadece Meta')}</span>
            : <PlatLogo p="google" size={18} />}
        </div>
        {canWrite && (added
          ? <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, fontSize: 12.5, fontWeight: 700, color: T.greenText }}><Sym name="check_circle" size={17} /> {t('Kuruldu')}</span>
          : <Button variant="solid" onClick={onPick}>{t('Kur')}</Button>)}
      </div>
    </Card>
  );
}

// ── Nasıl çalışır (boş durum) ──────────────────────────────────────────────

function HowItWorks({ isMobile }: { isMobile: boolean }) {
  const { t } = useLang();
  const steps: [string, string, string][] = [
    ['dashboard_customize', 'Şablon Seçin', 'Hazır RFM şablonlarından birini seçin ya da kendi kuralınızı yazın.'],
    ['ios_share', 'Reklam Hesabına Aktarılır', 'Kitle Meta ve Google Ads hesabınızda kural olarak oluşur, kampanyalarda hemen seçilebilir.'],
    ['autorenew', 'Her Gün Güncellenir', 'Platformlar üyeliği sürekli günceller; Poyais One her gün eşitler ve boyutu izler.'],
  ];
  return (
    <Card pad={20}>
      <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)', gap: isMobile ? 16 : 24 }}>
        {steps.map(([icon, title, text], i) => (
          <div key={i} style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
            <IconTile icon={icon} color={T.accent} size={38} />
            <div>
              <div style={{ fontSize: 13.5, fontWeight: 800, color: T.text }}><span style={{ color: T.accent }}>{i + 1}.</span> {t(title)}</div>
              <div style={{ fontSize: 12.5, color: T.textMid, lineHeight: 1.5, marginTop: 3 }}>{t(text)}</div>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
}

// ── Editör (sağdan açılan panel) ───────────────────────────────────────────

function SideBuilder({ value, onChange, accent }: { value: Side; onChange: (s: Side) => void; accent: string }) {
  const { t } = useLang();
  const custom = !DAY_CHIPS.includes(value.days);
  const pill = (on: boolean): React.CSSProperties => ({
    padding: '7px 12px', borderRadius: 9, fontFamily: 'inherit', fontSize: 12.5, fontWeight: 700, cursor: 'pointer',
    border: `1px solid ${on ? accent : T.borderMid}`, background: on ? tint(accent, 10) : T.surface, color: on ? T.text : T.textMid,
  });
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 8 }}>
        {EVENTS.map(ev => {
          const on = value.event === ev.key;
          return (
            <button key={ev.key} type="button" onClick={() => onChange({ ...value, event: ev.key, url: ev.key === 'PageView' ? (value.url || '') : undefined })}
              style={{ display: 'flex', alignItems: 'center', gap: 9, padding: '11px 12px', borderRadius: 11, cursor: 'pointer', fontFamily: 'inherit', fontSize: 13, fontWeight: 700, textAlign: 'left',
                border: `1.5px solid ${on ? accent : T.borderMid}`, background: on ? tint(accent, 8) : T.surface, color: T.text }}>
              <Sym name={ev.icon} size={18} color={on ? accent : T.textDim} /> {t(ev.label)}
            </button>
          );
        })}
      </div>
      {value.event === 'PageView' && (
        <label style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          <span style={{ fontSize: 12, fontWeight: 700, color: T.textDim }}>{t('Sayfa adresi şunu içeriyorsa')}</span>
          <input value={value.url || ''} maxLength={120} placeholder={t('Örn. /collections/kadin')} onChange={e => onChange({ ...value, url: e.target.value })}
            style={{ width: '100%', boxSizing: 'border-box', padding: '10px 12px', borderRadius: 10, border: `1px solid ${T.borderMid}`, background: T.surface, color: T.text, fontFamily: 'inherit', fontSize: 13.5 }} />
        </label>
      )}
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
        <span style={{ fontSize: 12, fontWeight: 700, color: T.textDim, marginRight: 4 }}>{t('Zaman Aralığı')}</span>
        {DAY_CHIPS.map(d => <button key={d} type="button" onClick={() => onChange({ ...value, days: d })} style={pill(value.days === d)}>{d} {t('Gün')}</button>)}
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, ...pill(custom), padding: '3px 6px 3px 10px' }}>
          {t('Özel')}
          <input type="number" min={1} max={180} value={value.days}
            onChange={e => onChange({ ...value, days: Math.max(1, Math.min(180, Number(e.target.value) || 1)) })}
            style={{ width: 52, padding: '4px 6px', borderRadius: 7, border: `1px solid ${T.borderMid}`, background: T.surface, color: T.text, fontFamily: 'inherit', fontSize: 12.5 }} />
        </span>
      </div>
    </div>
  );
}

function Section({ n, title, children, right }: { n: number; title: string; children: React.ReactNode; right?: React.ReactNode }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
          <span style={{ width: 22, height: 22, borderRadius: 99, background: T.ink, color: '#fff', fontSize: 11.5, fontWeight: 800, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{n}</span>
          <span style={{ fontSize: 14, fontWeight: 800, color: T.text }}>{title}</span>
        </div>
        {right}
      </div>
      {children}
    </div>
  );
}

function Switch({ on, onChange }: { on: boolean; onChange: (v: boolean) => void }) {
  return (
    <button type="button" onClick={() => onChange(!on)} aria-pressed={on}
      style={{ width: 40, height: 23, borderRadius: 99, border: 'none', cursor: 'pointer', position: 'relative', background: on ? T.accent : T.trackBg, transition: 'background .15s', flexShrink: 0 }}>
      <span style={{ position: 'absolute', top: 3, left: on ? 20 : 3, width: 17, height: 17, borderRadius: 99, background: '#fff', boxShadow: '0 1px 3px rgba(0,0,0,.25)', transition: 'left .15s' }} />
    </button>
  );
}

function Editor({ clientId, initial, connections, isMobile, onClose, onSaved }:
  { clientId: number; initial: { id?: number; template_key?: string; name: string; spec: Spec; platforms: string[]; enabled?: boolean };
    connections: { meta: boolean; google: boolean }; isMobile: boolean; onClose: () => void; onSaved: (a: Audience) => void }) {
  const { t } = useLang();
  const describe = useDescribe();
  const [name, setName] = useState(initial.name);
  const [inc, setInc] = useState<Side>(initial.spec.include);
  const [exc, setExc] = useState<Side | null>(initial.spec.exclude || null);
  const [minCount, setMinCount] = useState<number | ''>(initial.spec.min_count || '');
  const [plats, setPlats] = useState<string[]>(initial.platforms);
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState('');

  useEffect(() => {
    const esc = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', esc);
    return () => window.removeEventListener('keydown', esc);
  }, [onClose]);

  const isPurchase = inc.event === 'Purchase';
  const spec: Spec = { include: inc, exclude: exc, min_count: isPurchase && minCount && minCount > 1 ? Number(minCount) : null };
  const googleBlocked = !!(spec.min_count || inc.event === 'InitiateCheckout' || exc?.event === 'InitiateCheckout');
  const urlMissing = (inc.event === 'PageView' && (inc.url || '').trim().length < 2) || (exc?.event === 'PageView' && (exc.url || '').trim().length < 2);
  const effective = plats.filter(p => !(p === 'google' && googleBlocked));
  const look = LOOK[initial.template_key || ''] || CUSTOM_LOOK;

  const save = async () => {
    setSaving(true); setErr('');
    try {
      const body = { client_id: clientId, name: name.trim(), spec, platforms: effective, template_key: initial.template_key || '', enabled: initial.enabled ?? true };
      const r = initial.id ? await axios.put(`${API}/${initial.id}`, body) : await axios.post(API, body);
      onSaved(r.data);
    } catch (e) { setErr(errText(e)); } finally { setSaving(false); }
  };

  const input: React.CSSProperties = { width: '100%', boxSizing: 'border-box', padding: '10px 12px', borderRadius: 10, border: `1px solid ${T.borderMid}`, background: T.surface, color: T.text, fontFamily: 'inherit', fontSize: 13.5 };
  const small: React.CSSProperties = { fontSize: 12, fontWeight: 700, color: T.textDim };

  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(15,17,35,.42)', zIndex: 1000, display: 'flex', justifyContent: 'flex-end' }}>
      <div onClick={e => e.stopPropagation()}
        style={{ width: isMobile ? '100%' : 520, height: '100%', background: T.surface, display: 'flex', flexDirection: 'column', boxShadow: '-20px 0 50px rgba(0,0,0,.18)', animation: 'saSlide .18s ease-out' }}>
        {/* başlık */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '18px 22px', borderBottom: `1px solid ${T.divider}` }}>
          <IconTile icon={look.icon} color={look.color} size={36} />
          <div style={{ flex: 1, fontSize: 16.5, fontWeight: 800, color: T.text }}>{initial.id ? t('Düzenle') : t('Yeni Kitle')}</div>
          <button onClick={onClose} aria-label="close" style={{ width: 32, height: 32, borderRadius: 9, border: 'none', background: T.subtleBg, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: T.textMid }}>
            <Sym name="close" size={18} />
          </button>
        </div>

        {/* gövde */}
        <div style={{ flex: 1, overflowY: 'auto', padding: 22, display: 'flex', flexDirection: 'column', gap: 26 }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 7 }}>
            <span style={small}>{t('Kitle Adı')}</span>
            <input value={name} maxLength={80} onChange={e => setName(e.target.value)} style={input} autoFocus={!initial.name} />
          </div>

          <Section n={1} title={t('Kimler Dahil?')}>
            <SideBuilder value={inc} onChange={setInc} accent={T.accent} />
          </Section>

          {isPurchase && (
            <Section n={2} title={t('Ek Koşullar')} right={<Badge color={T.purpleText}>{t('Sadece Meta')}</Badge>}>
              <label style={{ display: 'flex', flexDirection: 'column', gap: 6, maxWidth: 240 }}>
                <span style={small}>{t('En Az Satın Alma Sayısı')}</span>
                <input type="number" min={1} max={50} placeholder="1" value={minCount} onChange={e => setMinCount(e.target.value === '' ? '' : Number(e.target.value))} style={input} />
              </label>
            </Section>
          )}

          <Section n={isPurchase ? 3 : 2} title={t('Kimler Hariç?')}
            right={<Switch on={!!exc} onChange={v => setExc(v ? { event: 'Purchase', days: Math.min(inc.days, 30) } : null)} />}>
            {exc ? <SideBuilder value={exc} onChange={setExc} accent={T.red} />
              : <div style={{ fontSize: 12.5, color: T.textDim }}>{t('Hariç tutulacak bir davranış ekleyin')}</div>}
          </Section>

          <Section n={isPurchase ? 4 : 3} title={t('Platformlar')}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 10 }}>
              {PLATS.map(p => {
                const blocked = p === 'google' && googleBlocked;
                const on = plats.includes(p) && !blocked;
                const sub = blocked ? t('Bu kurguyu desteklemiyor') : connections[p] ? t('Bağlı') : t('Bağlı Değil');
                return (
                  <button key={p} type="button" disabled={blocked} onClick={() => setPlats(plats.includes(p) ? plats.filter(x => x !== p) : [...plats, p])}
                    style={{ display: 'flex', alignItems: 'center', gap: 10, padding: 12, borderRadius: 12, textAlign: 'left', fontFamily: 'inherit', cursor: blocked ? 'not-allowed' : 'pointer',
                      border: `1.5px solid ${on ? T.accent : T.borderMid}`, background: on ? tint(T.accent, 8) : T.surface, opacity: blocked ? 0.55 : 1 }}>
                    <PlatLogo p={p} size={24} />
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: 13.5, fontWeight: 800, color: T.text }}>{PLAT[p].label}</div>
                      <div style={{ fontSize: 11.5, color: blocked || !connections[p] ? T.textDim : T.greenText, marginTop: 2 }}>{sub}</div>
                    </div>
                    <Sym name={on ? 'check_circle' : 'radio_button_unchecked'} size={20} color={on ? T.accent : T.textFaint} />
                  </button>
                );
              })}
            </div>
            {googleBlocked && <div style={{ fontSize: 12, color: T.textDim, lineHeight: 1.5 }}>
              {spec.min_count ? t('Sıklık koşulu sadece Meta\'da çalışır.') : t('Bu kurguyu desteklemiyor') + ': Google Ads · ' + t('Ödeme Başlatma')}
            </div>}
          </Section>
        </div>

        {/* alt bar: önizleme + kaydet */}
        <div style={{ borderTop: `1px solid ${T.divider}`, padding: '16px 22px', display: 'flex', flexDirection: 'column', gap: 12, background: T.surface }}>
          <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start', background: tint(T.accent, 8), borderRadius: 12, padding: '10px 12px' }}>
            <Sym name="groups" size={18} color={T.accent} />
            <div style={{ fontSize: 12.5, color: T.text, lineHeight: 1.55 }}><b>{t('Bu Kitle')}:</b> {describe(spec)}</div>
          </div>
          {err && <div style={{ fontSize: 12.5, color: T.redText }}>{err}</div>}
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
            <Button variant="ghost" onClick={onClose}>{t('Vazgeç')}</Button>
            <Button variant="solid" onClick={save} disabled={saving || !name.trim() || !effective.length || urlMissing}>
              {saving ? t('Kaydediliyor…') : t('Kaydet ve Aktar')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}


// ── Benzer kitle satırı + oluşturma penceresi ──────────────────────────────

function LookalikeRow({ l, canWrite, onDelete }: { l: Lookalike; canWrite: boolean; onDelete: () => void }) {
  const { t } = useLang();
  const fmt = useFmt();
  const map: Record<string, [string, string]> = { ready: [T.green, ''], populating: [T.blue, t('Dolduruluyor')], warning: [T.amber, t('Uyarı')], error: [T.red, t('Hata')] };
  const [dot, label] = map[l.status] || [T.textFaint, t('Bekliyor')];
  const size = l.status === 'ready' && l.size_high ? (l.size_low != null && l.size_low !== l.size_high ? `${fmt(l.size_low)}–${fmt(l.size_high)}` : fmt(l.size_high)) : '';
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 10px', borderRadius: 10, background: T.subtleBg }}>
      <Sym name="group_add" size={16} color={T.textMid} />
      <span style={{ fontSize: 12.5, fontWeight: 700, color: T.text, whiteSpace: 'nowrap' }}>{t('Benzer Kitle')} · {l.country} · %{Math.round(l.ratio * 100)}</span>
      <span style={{ width: 7, height: 7, borderRadius: 99, background: dot, flexShrink: 0 }} />
      <span title={l.error} style={{ fontSize: 12.5, color: T.textMid, flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{size || label}</span>
      <PlatLogo p="meta" size={14} />
      {canWrite && <button onClick={onDelete} aria-label="delete" style={{ border: 'none', background: 'transparent', cursor: 'pointer', color: T.textDim, display: 'flex', padding: 2 }}><Sym name="close" size={16} /></button>}
    </div>
  );
}

const COUNTRY_LABEL: Record<string, string> = { TR: 'Türkiye', US: 'ABD', DE: 'Almanya', GB: 'Birleşik Krallık', NL: 'Hollanda', FR: 'Fransa', AE: 'BAE', SA: 'Suudi Arabistan', AZ: 'Azerbaycan', KZ: 'Kazakistan', UZ: 'Özbekistan', CY: 'Kıbrıs' };

function LookalikeModal({ a, info, onClose, onDone }:
  { a: Audience; info: { countries: string[]; ratios: number[]; min_seed: number }; onClose: () => void; onDone: (x: Audience) => void }) {
  const { t } = useLang();
  const [country, setCountry] = useState('TR');
  const [ratios, setRatios] = useState<number[]>([0.01, 0.03]);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const [results, setResults] = useState<{ ratio: number; status: string; error?: string }[] | null>(null);
  const seed = a.meta_size_low ?? 0;
  const tooSmall = seed < info.min_seed;
  const existsFor = (r: number) => (a.lookalikes || []).some(l => l.country === country && Math.abs(l.ratio - r) < 0.001);
  const todo = ratios.filter(r => !existsFor(r));
  useEffect(() => {
    const esc = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', esc);
    return () => window.removeEventListener('keydown', esc);
  }, [onClose]);
  const go = async () => {
    setBusy(true); setErr('');
    try {
      const r = await axios.post(`${API}/${a.id}/lookalikes`, { country, ratios: todo });
      onDone(r.data.audience);
      const failed = (r.data.results || []).filter((x: any) => x.status === 'error');
      if (failed.length) setResults(r.data.results); else onClose();
    } catch (e) { setErr(errText(e)); } finally { setBusy(false); }
  };
  const field: React.CSSProperties = { width: '100%', boxSizing: 'border-box', padding: '10px 12px', borderRadius: 10, border: `1px solid ${T.borderMid}`, background: T.surface, color: T.text, fontFamily: 'inherit', fontSize: 13.5 };
  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(15,17,35,.42)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div onClick={e => e.stopPropagation()} style={{ background: T.surface, borderRadius: 18, width: 'min(480px, 100%)', maxHeight: '90vh', overflowY: 'auto', padding: 22, display: 'flex', flexDirection: 'column', gap: 16, boxShadow: '0 24px 60px rgba(0,0,0,.25)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <IconTile icon="group_add" color={T.purple} size={38} />
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 16.5, fontWeight: 800, color: T.text }}>{t('Benzer Kitle Oluştur')}</div>
            <div style={{ fontSize: 12.5, color: T.textDim, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{a.name}</div>
          </div>
          <PlatLogo p="meta" size={20} />
        </div>
        {tooSmall && <div style={{ fontSize: 12.5, color: T.amberDeepText, background: T.amberTint, borderRadius: 10, padding: '9px 11px', lineHeight: 1.5 }}>
          {t('Meta, benzer kitle için kaynak kitlenin en az 100 kişi olmasını ister.')} (~{seed})
        </div>}
        <label style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          <span style={{ fontSize: 12, fontWeight: 700, color: T.textDim }}>{t('Hedef Ülke')}</span>
          <select value={country} onChange={e => setCountry(e.target.value)} style={field}>
            {info.countries.map(c => <option key={c} value={c}>{COUNTRY_LABEL[c] || c} ({c})</option>)}
          </select>
        </label>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <span style={{ fontSize: 12, fontWeight: 700, color: T.textDim }}>{t('Benzerlik Oranı')}</span>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            {info.ratios.map(r => {
              const on = ratios.includes(r), exists = existsFor(r);
              return (
                <button key={r} type="button" disabled={exists} onClick={() => setRatios(on ? ratios.filter(x => x !== r) : [...ratios, r])}
                  style={{ padding: '9px 16px', borderRadius: 10, fontFamily: 'inherit', fontSize: 13, fontWeight: 800, cursor: exists ? 'not-allowed' : 'pointer',
                    border: `1.5px solid ${on && !exists ? T.accent : T.borderMid}`, background: on && !exists ? tint(T.accent, 10) : T.surface, color: exists ? T.textFaint : T.text }}>
                  %{Math.round(r * 100)}{exists ? ' ✓' : ''}
                </button>
              );
            })}
          </div>
          <div style={{ fontSize: 12, color: T.textDim, lineHeight: 1.5 }}>{t('Dar oran kaynağa daha çok benzer, geniş oran daha çok kişiye ulaşır. Birkaç oranı birlikte seçip test edebilirsiniz.')}</div>
        </div>
        {results && <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          {results.map(r => <div key={r.ratio} style={{ fontSize: 12.5, color: r.status === 'error' ? T.redText : T.greenText }}>%{Math.round(r.ratio * 100)}: {r.status === 'error' ? r.error : '✓'}</div>)}
        </div>}
        {err && <div style={{ fontSize: 12.5, color: T.redText, lineHeight: 1.5 }}>{err}</div>}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <Button variant="ghost" onClick={onClose}>{t('Vazgeç')}</Button>
          <Button variant="solid" onClick={go} disabled={busy || !todo.length || tooSmall}>{busy ? t('Oluşturuluyor…') : t('Oluştur')}</Button>
        </div>
      </div>
    </div>
  );
}

// ── Poyais One AI önerileri ─────────────────────────────────────────────────

const PRIORITY: Record<number, [string, string]> = { 1: ['Yüksek Öncelik', T.greenText], 2: ['Orta Öncelik', T.blueText], 3: ['Düşük Öncelik', T.textDim] };
const SUG_ICON: Record<string, [string, string]> = {
  retarget: ['shopping_cart_checkout', T.blue], upsell: ['person_add', T.green], winback: ['hourglass_bottom', T.amber],
  loyalty: ['favorite', T.purple], interest: ['travel_explore', T.accent],
};

function SuggestionCard({ sg, canWrite, onAccept, onDismiss, busy }: { sg: Suggestion; canWrite: boolean; onAccept: () => void; onDismiss: () => void; busy: boolean }) {
  const { t, lang } = useLang();
  const fmt = useFmt();
  const [icon, color] = SUG_ICON[sg.kind] || ['auto_awesome', T.accent];
  const [plabel, pcolor] = PRIORITY[sg.priority] || PRIORITY[2];
  const pct = (x: number) => `%${(x * 100).toFixed(1).replace('.', lang === 'en' ? '.' : ',')}`;
  return (
    <Card pad={18} hover style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 10 }}>
        <IconTile icon={icon} color={color} />
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
          <Badge color={pcolor}>{t(plabel)}</Badge>
          {sg.lookalike_ok && <Badge color={T.purpleText}>{t('Benzer kitle tohumu olabilir')}</Badge>}
        </div>
      </div>
      <div style={{ fontSize: 15, fontWeight: 800, color: T.text }}>{sg.name}</div>
      <RuleChips s={sg.spec} />
      <div style={{ fontSize: 13, color: T.text, lineHeight: 1.55 }}>{sg.rationale}</div>
      {(sg.est_size != null || sg.est_rate != null) && (
        <div style={{ display: 'grid', gridTemplateColumns: sg.est_size != null && sg.est_rate != null ? '1fr 1fr' : '1fr', gap: 8 }}>
          {sg.est_size != null && (
            <div style={{ background: T.subtleBg, borderRadius: 10, padding: '9px 11px' }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: T.textDim, textTransform: 'uppercase', letterSpacing: '.05em' }}>{t('Tahmini Kitle')}</div>
              <div style={{ fontSize: 18, fontWeight: 800, color: T.text, fontVariantNumeric: 'tabular-nums', marginTop: 2 }}>~{fmt(sg.est_size)}</div>
            </div>
          )}
          {sg.est_rate != null && (
            <div style={{ background: T.subtleBg, borderRadius: 10, padding: '9px 11px' }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: T.textDim, textTransform: 'uppercase', letterSpacing: '.05em' }}>{t('Aşama Dönüşümü')}</div>
              <div style={{ fontSize: 18, fontWeight: 800, color: T.text, fontVariantNumeric: 'tabular-nums', marginTop: 2 }}>{pct(sg.est_rate)}</div>
              <div style={{ fontSize: 11, color: T.textDim }}>{t('son 30 gün, kıyas değeri')}</div>
            </div>
          )}
        </div>
      )}
      {sg.use_case && (
        <div style={{ display: 'flex', gap: 8, alignItems: 'flex-start', fontSize: 12.5, color: T.textMid, lineHeight: 1.5, background: tint(T.accent, 8), borderRadius: 10, padding: '9px 11px' }}>
          <Sym name="lightbulb" size={16} color={T.accent} style={{ marginTop: 1 }} />
          <span><b style={{ color: T.text }}>{t('Önerilen kullanım')}:</b> {sg.use_case}</span>
        </div>
      )}
      {sg.watch_out && <div style={{ display: 'flex', gap: 6, alignItems: 'flex-start', fontSize: 12, color: T.amberDeepText, lineHeight: 1.45 }}><Sym name="info" size={15} style={{ marginTop: 1 }} /> {sg.watch_out}</div>}
      <div style={{ flex: 1 }} />
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, paddingTop: 12, borderTop: `1px solid ${T.divider}` }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <PlatLogo p="meta" size={18} />
          {sg.meta_only ? <span style={{ fontSize: 11.5, fontWeight: 600, color: T.textDim }}>{t('Sadece Meta')}</span> : <PlatLogo p="google" size={18} />}
        </div>
        {canWrite && (
          <div style={{ display: 'flex', gap: 8 }}>
            <Button variant="ghost" onClick={onDismiss} disabled={busy}>{t('Yoksay')}</Button>
            <Button variant="solid" onClick={onAccept} disabled={busy}>{busy ? '…' : t('Kur')}</Button>
          </div>
        )}
      </div>
    </Card>
  );
}

function AIPanel({ clientId, isMobile, onAccepted }: { clientId: number; isMobile: boolean; onAccepted: (a: Audience) => void }) {
  const { t, lang } = useLang();
  const [st, setSt] = useState<SugState | null>(null);
  const [err, setErr] = useState('');
  const [busyId, setBusyId] = useState<number | null>(null);
  const [starting, setStarting] = useState(false);

  const load = React.useCallback(async () => {
    try { const r = await axios.get(`${API}/suggestions?client_id=${clientId}`); setSt(r.data); setErr(''); return r.data as SugState; }
    catch (e) { setErr(errText(e)); return null; }
  }, [clientId]);

  useEffect(() => { setSt(null); load(); }, [load]);
  useEffect(() => {   // analiz sürerken 4 sn'de bir kontrol et
    if (!st?.running) return;
    const id = window.setInterval(() => { load(); }, 4000);
    return () => window.clearInterval(id);
  }, [st?.running, load]);

  const refresh = async () => {
    setStarting(true); setErr('');
    try { await axios.post(`${API}/suggestions/refresh?client_id=${clientId}`); await load(); }
    catch (e) { setErr(errText(e)); } finally { setStarting(false); }
  };
  const accept = async (sg: Suggestion) => {
    setBusyId(sg.id); setErr('');
    try { const r = await axios.post(`${API}/suggestions/${sg.id}/accept`); onAccepted(r.data); setSt(s => s && { ...s, items: s.items.filter(x => x.id !== sg.id) }); }
    catch (e) { setErr(errText(e)); } finally { setBusyId(null); }
  };
  const dismiss = async (sg: Suggestion) => {
    setBusyId(sg.id);
    try { await axios.post(`${API}/suggestions/${sg.id}/dismiss`); setSt(s => s && { ...s, items: s.items.filter(x => x.id !== sg.id) }); }
    catch (e) { setErr(errText(e)); } finally { setBusyId(null); }
  };

  const when = st?.analyzed_at ? new Date(st.analyzed_at + 'Z').toLocaleString(lang === 'en' ? 'en-GB' : 'tr-TR', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }) : '';
  const running = !!st?.running;
  const empty = !!st && !running && st.items.length === 0;
  return (
    <section style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
        <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start', maxWidth: 760 }}>
          <IconTile icon="auto_awesome" color={T.accent} size={40} />
          <div>
            <div style={{ fontSize: 17, fontWeight: 800, color: T.text }}>{t('Poyais One AI Önerileri')}</div>
            <div style={{ fontSize: 12.5, color: T.textDim, lineHeight: 1.55, marginTop: 3 }}>
              {t('Verileriniz (GA4, reklam performansı) kitle adaylarına çevrilir; kitle boyutları ve dönüşüm oranları ölçülmüş verilerdir, AI sadece önceliklendirir ve gerekçelendirir. Hiçbir kitle sizin onayınız olmadan kurulmaz.')}
            </div>
            {st && st.sources.length > 0 && (
              <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap', marginTop: 8 }}>
                <span style={{ fontSize: 11.5, fontWeight: 700, color: T.textDim }}>{t('Beslendiği Kaynaklar')}:</span>
                {st.sources.map(x => <Chip key={x}>{x}</Chip>)}
                {when && <span style={{ fontSize: 11.5, color: T.textDim, marginLeft: 4 }}>· {t('Son Analiz')}: {when}</span>}
              </div>
            )}
          </div>
        </div>
        {st?.can_write && !running && (
          <Button variant="ghost" onClick={refresh} disabled={starting}>
            <Sym name="refresh" size={16} /> {st.status === 'never' ? t('Analiz Et') : t('Yeniden Analiz Et')}
          </Button>
        )}
      </div>

      {err && <Card pad={14}><span style={{ color: T.redText, fontSize: 13 }}>{err}</span></Card>}

      {(running || !st) && (
        <Card pad={20}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, color: T.textMid, fontSize: 13.5 }}>
            <Sym name="progress_activity" size={22} color={T.accent} style={{ animation: 'spin 1s linear infinite' }} />
            {st ? t('Analiz ediliyor… (30–60 sn)') : '…'}
          </div>
        </Card>
      )}

      {st && !running && st.status === 'never' && (
        <Card pad={20}>
          <div style={{ fontSize: 13.5, color: T.textMid, lineHeight: 1.55 }}>{t('Henüz analiz yapılmadı. Poyais One AI müşterinizin verisini inceleyip size özel kitleler önersin.')}</div>
        </Card>
      )}
      {st && !running && (st.status === 'no_data' || (st.status === 'error' && st.items.length === 0)) && (
        <Card pad={16}><span style={{ fontSize: 13, color: T.amberDeepText }}>{st.error}</span></Card>
      )}
      {empty && st && st.status === 'done' && <Card pad={18}><span style={{ fontSize: 13.5, color: T.textMid }}>{t('Yeni öneri yok. Mevcut kitleleriniz verinizle uyumlu görünüyor.')}</span></Card>}

      {st && !running && st.items.length > 0 && (
        <>
          <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fill, minmax(340px, 1fr))', gap: 14 }}>
            {st.items.map(sg => <SuggestionCard key={sg.id} sg={sg} canWrite={st.can_write} busy={busyId === sg.id} onAccept={() => accept(sg)} onDismiss={() => dismiss(sg)} />)}
          </div>
          {!st.ai && <div style={{ fontSize: 12, color: T.textDim }}>{t('Otomatik sıralama kullanıldı (AI yanıt vermedi).')}</div>}
        </>
      )}
    </section>
  );
}

// ── Sayfa ──────────────────────────────────────────────────────────────────

export default function SmartAudiences({ clientId }: { clientId: number }) {
  const { t, lang } = useLang();
  const isMobile = useIsMobile();
  const [templates, setTemplates] = useState<Template[]>([]);
  const [items, setItems] = useState<Audience[]>([]);
  const [connections, setConnections] = useState({ meta: false, google: false });
  const [canWrite, setCanWrite] = useState(false);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');
  const [editing, setEditing] = useState<any>(null);
  const [lookalikeFor, setLookalikeFor] = useState<Audience | null>(null);
  const [lalInfo, setLalInfo] = useState({ countries: ['TR'], ratios: [0.01, 0.02, 0.03, 0.05, 0.1], min_seed: 100 });

  useEffect(() => {
    axios.get(`${API}/templates`).then(r => {
      (r.data.templates || []).forEach((x: Template) => { TEMPLATE_TR_NAME[x.key] = x.name; });
      setTemplates(r.data.templates || []);
    }).catch(() => {});
  }, []);

  useEffect(() => {
    let alive = true;
    setLoading(true); setErr('');
    axios.get(`${API}?client_id=${clientId}`)
      .then(r => { if (!alive) return; if (r.data.lookalike) setLalInfo(r.data.lookalike); setItems(r.data.items || []); setConnections(r.data.connections || { meta: false, google: false }); setCanWrite(!!r.data.can_write); })
      .catch(e => alive && setErr(errText(e)))
      .finally(() => alive && setLoading(false));
    return () => { alive = false; };
  }, [clientId]);

  const addedKeys = useMemo(() => new Set(items.map(i => i.template_key).filter(Boolean)), [items]);
  const defaultPlats = PLATS.filter(p => connections[p]);

  const pickTemplate = (tp: Template) => {
    const en = LOOK[tp.key]?.en;
    const plats = defaultPlats.filter(p => !(p === 'google' && tp.google_note));
    setEditing({ template_key: tp.key, name: lang === 'en' && en ? en[0] : tp.name, spec: tp.spec, platforms: plats.length ? plats : ['meta'] });
  };
  const upsert = (a: Audience) => setItems(xs => xs.some(x => x.id === a.id) ? xs.map(x => x.id === a.id ? a : x) : [a, ...xs]);
  const lastSync = items.map(i => i.last_sync_at || '').sort().pop();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 28 }}>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}@keyframes saSlide{from{transform:translateX(24px);opacity:.4}to{transform:none;opacity:1}}`}</style>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 14, flexWrap: 'wrap' }}>
        <div style={{ fontSize: 13.5, color: T.textMid, lineHeight: 1.55, maxWidth: 640 }}>
          {t('Sitenizdeki davranışa göre müşterilerinizi segmentlere ayırın; kitleler Meta ve Google Ads hesabınıza aktarılır ve her gün güncellenir.')}
        </div>
        {canWrite && <Button variant="solid" onClick={() => setEditing({ name: '', spec: { include: { event: 'Purchase', days: 30 } }, platforms: defaultPlats.length ? defaultPlats : ['meta'] })}>{t('Yeni Kitle')}</Button>}
      </div>

      {err && <Card pad={14}><span style={{ color: T.redText, fontSize: 13 }}>{err}</span></Card>}

      {items.length === 0 && <AIPanel clientId={clientId} isMobile={isMobile} onAccepted={upsert} />}

      {!loading && items.length === 0 && <HowItWorks isMobile={isMobile} />}

      {items.length > 0 && (
        <section style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: 10, flexWrap: 'wrap' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ fontSize: 17, fontWeight: 800, color: T.text }}>{t('Kitleleriniz')}</span>
              <Badge color={T.textMid}>{items.length}</Badge>
            </div>
            {lastSync && <span style={{ fontSize: 12, color: T.textDim }}>{t('Son Eşitleme')}: {new Date(lastSync + 'Z').toLocaleString(lang === 'en' ? 'en-GB' : 'tr-TR', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })}</span>}
          </div>
          <Card pad={0} style={{ overflow: 'visible' }}>
            {!isMobile && (
              <div style={{ display: 'grid', gridTemplateColumns: GRID, gap: 16, padding: '11px 18px', fontSize: 11, fontWeight: 700, color: T.textDim, textTransform: 'uppercase', letterSpacing: '.05em' }}>
                <span>{t('Kitle')}</span>
                <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}><PlatLogo p="meta" size={14} /> Meta</span>
                <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}><PlatLogo p="google" size={14} /> Google Ads</span>
                <span>{t('Trend')}</span>
                <span />
              </div>
            )}
            {items.map((a, i) => (
              <div key={a.id}>
                <AudienceRow a={a} canWrite={canWrite} isMobile={isMobile} first={i === 0 && isMobile}
                  onEdit={() => setEditing({ id: a.id, template_key: a.template_key, name: a.name, spec: a.spec, platforms: a.platforms, enabled: a.enabled })}
                  onLookalike={() => setLookalikeFor(a)}
                  onChanged={upsert} onDeleted={() => setItems(xs => xs.filter(x => x.id !== a.id))} />
              </div>
            ))}
          </Card>
        </section>
      )}

      {items.length > 0 && <AIPanel clientId={clientId} isMobile={isMobile} onAccepted={upsert} />}

      {!canWrite && !loading && <div style={{ fontSize: 12.5, color: T.textDim }}>{t('Görüntüleme yetkiniz var; kitle eklemek için Düzenleyici rolü gerekir.')}</div>}

      <section style={{ display: 'flex', flexDirection: 'column', gap: 22 }}>
        <div style={{ fontSize: 17, fontWeight: 800, color: T.text }}>{t('Hazır Şablonlar')}</div>
        {GROUPS.map(g => {
          const list = templates.filter(tp => (LOOK[tp.key]?.group || 'rfm') === g.key);
          if (!list.length) return null;
          return (
            <div key={g.key} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <div>
                <div style={{ fontSize: 14, fontWeight: 800, color: T.text }}>{t(g.title)}</div>
                <div style={{ fontSize: 12.5, color: T.textDim, marginTop: 2 }}>{t(g.sub)}</div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fill, minmax(270px, 1fr))', gap: 14 }}>
                {list.map(tp => <TemplateCard key={tp.key} tp={tp} added={addedKeys.has(tp.key)} canWrite={canWrite} onPick={() => pickTemplate(tp)} />)}
              </div>
            </div>
          );
        })}
      </section>

      <div style={{ display: 'flex', gap: 8, alignItems: 'flex-start', fontSize: 12, color: T.textDim, lineHeight: 1.6 }}>
        <Sym name="lock" size={15} color={T.textDim} style={{ marginTop: 2 }} />
        <span>{t('Kişisel veri (e-posta/telefon) yüklenmez; kitleler reklam hesabınızda piksel ve etiket kuralı olarak oluşur. Google listeleri geçmiş 30 günle, Meta kitleleri 180 güne kadar geçmişle dolar.')}</span>
      </div>

      {lookalikeFor && <LookalikeModal a={items.find(x => x.id === lookalikeFor.id) || lookalikeFor} info={lalInfo}
        onClose={() => setLookalikeFor(null)} onDone={upsert} />}

      {editing && <Editor clientId={clientId} initial={editing} connections={connections} isMobile={isMobile}
        onClose={() => setEditing(null)} onSaved={a => { upsert(a); setEditing(null); }} />}
    </div>
  );
}
